import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-duotone-svg-icons';

import './index.css';

function AddButton(props) {
    const { t } = useTranslation('tvplan');

    return (
    	<Button
            type="primary"
            className="tv-add-button"
            icon={<FontAwesomeIcon className='add-button-icon' icon={faBadgeCheck} />}
            onClick={props.onClick}>{t('Add')}</Button>
    );
}

export default AddButton;
